<script setup>
import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';

import SectionLayout from './SectionLayout.vue';

const { t } = useI18n();
const { currentAccount } = useAccount();
const globalConfig = useMapGetter('globalConfig/get');

const getAccountId = computed(() => currentAccount.value.id.toString());
const platformVersion = computed(() => globalConfig.value.appVersion || '');
</script>

<template>
  <SectionLayout
    :title="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.TITLE')"
    :description="t('GENERAL_SETTINGS.FORM.ACCOUNT_ID.NOTE')"
    with-border
  >
    <woot-code :script="getAccountId" />
    <p
      v-if="platformVersion"
      class="mt-2 text-sm text-n-slate-10"
    >
      Versão: {{ platformVersion }}
    </p>
  </SectionLayout>
</template>
